import * as React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import dynamic from "next/dynamic";
import Layout from "@/components/layout";
import { useWidth } from "@/utils/resize";
import { watchDom } from "@/watch";
import buriedsdk from "@/utils/zz-buried/index";
import { Switch } from "antd";
import PricingCombo from "@/components/pricongCombo";
import PricingComboMobile from "@/components/pricongCombo/mobile";
import Faqs from "@/components/faqs";
import { getPrices } from "@/service/index";
const PcFreestart = dynamic(import("@home3/pc/Freestart"));

import discount from "@images/pricng/discount.png";

type Props = {
  list: any[];
  isLogin: boolean;
};

let watchDoms: any = "";
const Index = (props: Props) => {
  const { list, isLogin } = props;
  const { t, i18n } = useTranslation("pricing");
  const dom: any = useRef();
  const { width, display } = useWidth();
  const [unit, setUnit] = useState(true);

  const mobileUrl = process.env.mobileUrl;
  const pcUrl = process.env.portalUrl;

  const questions = [
    {
      question: t("Q1"),
      id: 1,
      answer: t("A1"),
      isShow: true,
    },
    {
      question: t("Q2"),
      id: 2,
      answer: t("A2"),
      isShow: false,
    },
    {
      question: t("Q3"),
      id: 3,
      answer: t("A3"),
      isShow: false,
    },
    {
      question: t("Q4"),
      id: 4,
      answer: t("A4"),
      isShow: false,
    },
  ];

  useEffect(() => {
    if (process.browser) {
      if (dom.current) {
        if (watchDoms) clearInterval(watchDoms);
        watchDoms = watchDom();
      }
    }
  }, [dom]);

  return (
    <div>
      <Layout header={true} footer={true}>
        <Head>
          <title>{t("Page Title")}</title>
          <meta name="keywords" content={t("Page Keywords")}></meta>
          <meta name="description" content={t("Page Description")} />
          <script src="/js/jq.js" async />
          <script src="/js/kefu53.js" async />
        </Head>
        <div className={styles.down + " animate-box"} ref={dom}>
          <div className={styles.center}>
            <div className="defeaultContainer">
              <h2 className={styles.title + " ant"}>{t("Plans & Pricing")}</h2>
              <h4 className={styles.sub + " ant"}>{t("Choose a Plan")}</h4>
              <div className={styles.plan + " ant"}>
                <div className={(unit ? "text-[#8F97A3]" : "text-[#2E384E]") + " lg1024:text-[14px]"}>
                  {t("Monthly")}
                </div>
                <Switch
                  className={styles["switch-wrap"]}
                  checked={unit}
                  onChange={(bool) => {
                    buriedsdk.buried({
                      event: `按钮点击`,
                      scene: `价格页-切换月/年付按钮`,
                      URL: process.env.publicApiDomain,
                    });
                    setUnit(bool);
                  }}
                ></Switch>
                <div className={(unit ? "text-[#2E384E]" : "text-[#8F97A3]") + " lg1024:text-[14px] relative"}>
                  {t("Yearly")}
                  {/* <div className="absolute left-[17px] bottom-[10px] w-[128px] h-[52px]">
                    <Image src={discount} width={128} height={52}></Image>
                  </div> */}
                </div>
              </div>
              {width > 1024 ? (
                <PricingCombo
                  list={list}
                  isLogin={isLogin}
                  cycleUnit={unit ? "y" : "m"}
                ></PricingCombo>
              ) : (
                <PricingComboMobile
                  list={list}
                  isLogin={isLogin}
                  cycleUnit={unit ? "y" : "m"}
                ></PricingComboMobile>
              )}
            </div>
          </div>
        </div>
        <div>
          <Faqs
            list={questions}
            hideMoreButton={true}
            itemStyle={{
              background: "#F7F8FA",
              boxShadow: "none",
              margin: width > 1024 ? "" : "0 20px 20px",
              width: width > 1024 ? "100%" : "auto",
            }}
          ></Faqs>
          <PcFreestart></PcFreestart>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  const data = await getPrices({ systemId: 14 }, context);
  let list = [
    {
      comboName: "Basic",
      mPrice: "",
      yPrice: "",
      desc: "For individuals & start-up business",
      save: "$468 billed,save $120",
      info: [
        {
          tips: `Access to lists`,
          hard: "Top100",
          status: true,
        },
        {
          tips: `Access to details`,
          hard: "100 times/day",
          status: true,
        },
        {
          tips: `Sub-account`,
          type: 'left',
          hard: "No",
          status: false,
        },
      ],
    },
    {
      comboName: "Premium",
      mPrice: "",
      yPrice: "",
      desc: "For growing businesses",
      save: "$588 billed,save $240",
      info: [
        {
          tips: `Access to lists`,
          hard: "Top300",
          status: true,
        },
        {
          tips: `Access to details`,
          hard: "300 times/day",
          status: true,
        },
        {
          tips: `Sub-accounts`,
          type: 'left',
          hard: "2",
          status: true,
        },
      ],
    },
    {
      comboName: "Professional",
      mPrice: "",
      yPrice: "",
      desc: "For bigger teams & pro operations",
      save: "$948 billed,save $240",
      info: [
        {
          hard: "Unlimited",
          type: 'left',
          tips: `access to lists`,
          status: true,
        },
        {
          hard: "Unlimited",
          type: 'left',
          tips: `access to details`,
          status: true,
        },
        {
          tips: `Sub-accounts`,
          type: 'left',
          hard: "5",
          status: true,
        },
      ],
    },
  ];
  try {
    if (data && data.code === 0) {
      list = list.map((item) => ({
        ...item,
        mPrice: data.data
          .find((i) => i.name === item.comboName)
          ?.priceList.find((child) => child.cycleUnit === "m")?.price,
        yPrice: data.data
          .find((i) => i.name === item.comboName)
          ?.priceList.find((child) => child.cycleUnit === "y")?.price,
      }));
    }
  } catch (error) {
    console.log(error);
  }
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
        "pricing",
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
      list: list,
      isLogin: !!context.req.cookies["authorized-token"],
    },
  };
};

export default Index;
